import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  isHighContrast: false,
};

const accessibilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_CONTRAST:
      state = {
        isHighContrast: !state.isHighContrast,
      };
      break;
    default:
      break;
  }
  return state;
};

export default accessibilityReducer;



// WEBPACK FOOTER //
// ./src/reducers/accessibilityReducer.js